module.exports = __webpack_public_path__ + "img/sidebar-button-active-old.ec600de.webp";